import styled from 'styled-components'
import { Form } from 'antd'
export const MyForm = styled(Form)<{ $dark?: boolean }>`
  .ant-form-item-label {
    > label {
      color: ${props =>
        props.$dark ? props.theme['neutral-500'] : props.theme['neutral-400']};
      &.ant-form-item-required:before {
        color: ${props =>
          props.$dark
            ? props.theme['neutral-500']
            : props.theme['neutral-400']};
      }
    }
  }

  .ant-form-item-has-error {
    .ant-form-item-control-input {
      border-color: ${props => props.theme.error};
    }
  }

  .ant-input-show-count-suffix,
  .ant-input-textarea-show-count::after {
    color: ${props =>
      props.$dark ? props.theme['neutral-800'] : props.theme['neutral-400']};
  }

  .ant-input,
  .ant-input-number-input,
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    /* background: none; */
    color: ${props =>
      props.$dark ? props.theme['neutral-600'] : props.theme['neutral-100']};
    background: ${props =>
      props.$dark ? 'transparent' : props.theme['neutral-800']};
    &[disabled] {
      background: ${props =>
        props.$dark ? 'transparent' : props.theme['neutral-700']};
    }
    &::placeholder {
      color: ${props =>
        props.$dark ? props.theme['neutral-400'] : props.theme['neutral-500']};
    }
  }
  .ant-select-disabled.ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    background: ${props =>
      props.$dark ? 'transparent' : props.theme['neutral-700']};
  }
  .ant-select-selection-placeholder {
    color: ${props =>
      props.$dark ? props.theme['neutral-700'] : props.theme['neutral-500']};
  }

  .ant-input-affix-wrapper-status-error:not(
      .ant-input-affix-wrapper-disabled
    ):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper,
  .ant-input-affix-wrapper-status-error:not(
      .ant-input-affix-wrapper-disabled
    ):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover,
  .ant-input-status-error:not(.ant-input-disabled):not(
      .ant-input-borderless
    ).ant-input,
  .ant-input-status-error:not(.ant-input-disabled):not(
      .ant-input-borderless
    ).ant-input:hover {
    background: ${props => (props.$dark ? 'transparent' : '#fff')};
  }

  /* TODO 考虑更好的实现方式 */
  .my-form-item {
    .ant-form-item-control-input {
      border: none;
      color: ${props =>
        props.$dark ? props.theme['neutral-400'] : props.theme['neutral-200']};
    }
  }

  .my-form-row-item {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .ant-form-item-control-input {
      border: none;
      color: ${props => props.theme['neutral-200']};
    }
    .ant-form-item-label {
      padding-bottom: 0;
    }
    .ant-radio-wrapper {
      margin: 0 0 0 16px;
    }
    span.ant-radio + * {
      padding: 0 0 0 8px;
    }
    .ant-form-item-control {
      flex-grow: inherit;
    }
  }

  .ant-form-item-control-input {
    border: 2px solid
      ${props =>
        props.$dark ? props.theme['neutral-300'] : props.theme['neutral-600']};
    border-radius: 12px;
    .ant-input {
      line-height: 24px;
      padding: 10px 16px !important;
      border: none;
      border-radius: 12px;
    }
    .ant-input-affix-wrapper {
      padding: 0;
      border-radius: 12px;
      border: none;
      background: none;
      &:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .ant-input-suffix {
        padding: 0 12px;
      }
    }
    .ant-input-group-wrapper {
      background: none;
      .ant-input-group-addon {
        position: relative;
        background: none;
        color: ${props => props.theme['neutral-400']};
        border: none;
        &:last-child::before {
          content: '';
          position: absolute;
          top: 12px;
          bottom: 12px;
          left: 0;
          width: 1px;
          background-color: ${props => props.theme['neutral-300']};
        }
      }
      .ant-input {
        &:first-child {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
        &:last-child {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }
    }

    .ant-picker {
      border: none;
      border-radius: 12px;
      height: 44px;
    }
  }

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    border: none;
    border-radius: 12px;
    height: 44px;
    padding: 6px 16px;
  }

  .ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector
    .ant-select-selection-search-input {
    height: 40px;
  }

  .ant-input-number-group-wrapper {
    display: block;
  }

  .ant-input-number {
    border: none;
    border-radius: 12px;
  }

  .ant-input-number-input {
    height: 44px;
    padding: 0 8px;
    border-radius: 12px;
  }

  .ant-input-number-group-addon {
    border: none;
    background: none;
    color: ${props => props.theme['neutral-200']};
  }
`
export const MyFormDivide = styled.div<{ dark?: boolean }>`
  height: 1px;
  background-color: ${props =>
    props.dark ? props.theme['neutral-300'] : props.theme['neutral-600']};
  margin: 40px auto;
`
